export default "__VITE_ASSET__y$mLALZx__"